import * as React from "react"
import ServiceHeader from 'components/Service/ServiceHeader';
import ServiceList from 'components/Service/ServiceList';
import FeaturedCaseStudies from 'components/CaseStudy/FeaturedCaseStudies';
import ServiceListSlider from 'components/Service/ServiceListSlider';
import InsightsSlider from 'components/Insights/InsightsSlider';
import LetsCollaborate from 'components/LetsCollaborate';

const Service = ({ page, service }) => {
	const pageFooter = page?.additionalFields?.pageFooter || 'lets-collaborate';
	const footerComponents = {
		'lets-collaborate': LetsCollaborate,
		// Add more footer types here if needed, e.g., 'custom-footer': CustomFooter
	};

	let caseStudies = (service.CaseStudy && service.CaseStudy.length) ? service.CaseStudy.map(({ object }) => ({
		id: object.id,
        uri: object.uri,
        title: object.title,
        headerImage: object.headerImage,
		Industry: {
			object: {
				name: service.name,
			}
		}
	})) : [];

	if (caseStudies.length > 3) caseStudies.length = 3;

	const posts = (service.Post && service.Post.length) ? service.Post.map(({ object }) => ({
		id: object.id,
		uri: object.uri,
		title: object.title,
		intro: object.intro,
		photo: object.photo,
	})) : null;

	const FooterComponent = footerComponents[pageFooter] || null;

	return (
		<>
			<ServiceHeader uri={service.uri} useH1 />
			<ServiceList title={service.heroTitle} text={service.heroText} services={service.services} />
			{caseStudies.length > 0 && <FeaturedCaseStudies title={`${service.name} Case Studies`} caseStudies={caseStudies} />}
			<ServiceListSlider title={"More Services"} link={"/services/"} linkText={"View All Services"} blacklist={service.id} />
			<InsightsSlider title={"Fresh Intel"} link={"/insights/"} linkText={"View All Insights"} data={posts} />
			{FooterComponent && <FooterComponent />}
		</>
	)
}

export default Service;